export default "__VITE_ASSET__CBZmrAng__"